import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import './MultiLineEllipsis.less';

const block = bemBlock('multiline-ellipsis');

type MultiLineMiddleEllipsisProps = {
  text: string;
  limit?: number;
  onTruncationChange?: (isTruncated: boolean) => void;
};

export const MultiLineEllipsis = ({
  text,
  limit = 500,
  onTruncationChange,
}: MultiLineMiddleEllipsisProps) => {
  const revealedRef = React.useRef<HTMLSpanElement>(null);

  const isTruncated = limit < text.length;

  React.useEffect(() => {
    onTruncationChange?.(isTruncated);
  }, [isTruncated, onTruncationChange]);

  const revealed = text.slice(0, limit);

  const handleCopy = (e: React.ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.clipboardData.setData('text/plain', text);
  };

  return (
    <span
      onCopy={handleCopy}
      className={block({ modifiers: { truncated: isTruncated } })}
      title={text}
    >
      {isTruncated ? (
        <>
          <span ref={revealedRef} className={block('text')}>
            {revealed}
          </span>
          <span>...</span>
        </>
      ) : (
        <span>{text}</span>
      )}
    </span>
  );
};
